// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_documentapis__Buhta_document_v1alpha1_document from "./buhta_document_v1alpha1_document.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetDocumentRequest = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_service.ml",
  1608,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const GetDocumentResponse = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_service.ml",
  1671,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ListDocumentsRequest = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_service.ml",
  1731,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ListDocumentsResponse = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_service.ml",
  1791,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const CreateDocumentRequest = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_service.ml",
  1851,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const CreateDocumentResponse = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_service.ml",
  1911,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const UpdateDocumentRequest = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_service.ml",
  2000,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "DocumentData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const UpdateDocumentResponse = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_service.ml",
  2117,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const DeleteDocumentRequest = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_service.ml",
  2177,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const DeleteDocumentResponse = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_service.ml",
  2235,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.edo.document.v1alpha1.GetDocumentRequest";
}

function make(idOpt, expandOpt, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const expand = expandOpt !== undefined ? expandOpt : /* [] */ 0;
  return {
    id: id,
    expand: expand
  };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    2,
    "expand",
    "expand"
  ],
  Ocaml_protoc_plugin__Spec.string,
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge(t1, t2) {
  return {
    id: Curry._2(merge_id, t1.id, t2.id),
    expand: Curry._2(merge_expand, t1.expand, t2.expand)
  };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      2,
      "expand",
      "expand"
    ],
    Ocaml_protoc_plugin__Spec.string,
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.id, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, expand) {
  return {
    id: id,
    expand: expand
  };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.GetDocumentRequest", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.expand);
  };
}

function constructor$1(id, expand) {
  return {
    id: id,
    expand: expand
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.GetDocumentRequest", spec(undefined), constructor$1);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GetDocumentRequest, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

function name$1(param) {
  return ".buhta.edo.document.v1alpha1.GetDocumentResponse";
}

function make$1($$document, param) {
  return {
    document: $$document
  };
}

const $$let = Buhta_documentapis__Buhta_document_v1alpha1_document.Buhta.$$Document.V1alpha1.$$Document;

const merge_document = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "document",
    "document"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let.name,
    make: $$let.make,
    from_proto: $$let.from_proto,
    from_proto_exn: $$let.from_proto_exn,
    to_proto: $$let.to_proto,
    to_proto$p: $$let.to_proto$p,
    merge: $$let.merge,
    to_json: $$let.to_json,
    from_json_exn: $$let.from_json_exn,
    from_json: $$let.from_json
  })
]));

function merge$1(t1, t2) {
  return {
    document: Curry._2(merge_document, t1.document, t2.document)
  };
}

function spec$1(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_document.Buhta.$$Document.V1alpha1.$$Document;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "document",
      "document"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
});

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.document);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2($$document) {
  return {
    document: $$document
  };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
});

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$1, writer);
  });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.GetDocumentResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.document);
  };
}

function constructor$3($$document) {
  return {
    document: $$document
  };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.GetDocumentResponse", spec$1(undefined), constructor$3);
});

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$1, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GetDocumentResponse, {
  make: make$1,
  to_proto: to_proto$1,
  from_proto: from_proto$1,
  to_json: to_json$1,
  from_json: from_json$1,
  name: name$1,
  merge: merge$1,
  to_proto$p: to_proto$p$1,
  from_proto_exn: from_proto_exn$1,
  from_json_exn: from_json_exn$1
});

function name$2(param) {
  return ".buhta.edo.document.v1alpha1.ListDocumentsRequest";
}

function make$2(grid, param) {
  return {
    grid: grid
  };
}

const $$let$1 = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "grid",
    "grid"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$1.name,
    make: $$let$1.make,
    from_proto: $$let$1.from_proto,
    from_proto_exn: $$let$1.from_proto_exn,
    to_proto: $$let$1.to_proto,
    to_proto$p: $$let$1.to_proto$p,
    merge: $$let$1.merge,
    to_json: $$let$1.to_json,
    from_json_exn: $$let$1.from_json_exn,
    from_json: $$let$1.from_json
  })
]));

function merge$2(t1, t2) {
  return {
    grid: Curry._2(merge_grid, t1.grid, t2.grid)
  };
}

function spec$2(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "grid",
      "grid"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
});

function to_proto$p$2(writer, param) {
  Curry._2(serialize$2, writer, param.grid);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(grid) {
  return {
    grid: grid
  };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
});

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$2, writer);
  });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.ListDocumentsRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.grid);
  };
}

function constructor$5(grid) {
  return {
    grid: grid
  };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.ListDocumentsRequest", spec$2(undefined), constructor$5);
});

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$2, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ListDocumentsRequest, {
  make: make$2,
  to_proto: to_proto$2,
  from_proto: from_proto$2,
  to_json: to_json$2,
  from_json: from_json$2,
  name: name$2,
  merge: merge$2,
  to_proto$p: to_proto$p$2,
  from_proto_exn: from_proto_exn$2,
  from_json_exn: from_json_exn$2
});

function name$3(param) {
  return ".buhta.edo.document.v1alpha1.ListDocumentsResponse";
}

function make$3(documentsOpt, param) {
  const documents = documentsOpt !== undefined ? documentsOpt : /* [] */ 0;
  return {
    documents: documents
  };
}

const $$let$2 = Buhta_documentapis__Buhta_document_v1alpha1_document.Buhta.$$Document.V1alpha1.$$Document;

const merge_documents = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    1,
    "documents",
    "documents"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$2.name,
    make: $$let$2.make,
    from_proto: $$let$2.from_proto,
    from_proto_exn: $$let$2.from_proto_exn,
    to_proto: $$let$2.to_proto,
    to_proto$p: $$let$2.to_proto$p,
    merge: $$let$2.merge,
    to_json: $$let$2.to_json,
    from_json_exn: $$let$2.from_json_exn,
    from_json: $$let$2.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$3(t1, t2) {
  return {
    documents: Curry._2(merge_documents, t1.documents, t2.documents)
  };
}

function spec$3(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_document.Buhta.$$Document.V1alpha1.$$Document;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      1,
      "documents",
      "documents"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
});

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.documents);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(documents) {
  return {
    documents: documents
  };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
});

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$3, writer);
  });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.ListDocumentsResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.documents);
  };
}

function constructor$7(documents) {
  return {
    documents: documents
  };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.ListDocumentsResponse", spec$3(undefined), constructor$7);
});

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$3, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ListDocumentsResponse, {
  make: make$3,
  to_proto: to_proto$3,
  from_proto: from_proto$3,
  to_json: to_json$3,
  from_json: from_json$3,
  name: name$3,
  merge: merge$3,
  to_proto$p: to_proto$p$3,
  from_proto_exn: from_proto_exn$3,
  from_json_exn: from_json_exn$3
});

function name$4(param) {
  return ".buhta.edo.document.v1alpha1.CreateDocumentRequest";
}

function make$4($$document, param) {
  return {
    document: $$document
  };
}

const $$let$3 = Buhta_documentapis__Buhta_document_v1alpha1_document.Buhta.$$Document.V1alpha1.$$Document;

const merge_document$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "document",
    "document"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$3.name,
    make: $$let$3.make,
    from_proto: $$let$3.from_proto,
    from_proto_exn: $$let$3.from_proto_exn,
    to_proto: $$let$3.to_proto,
    to_proto$p: $$let$3.to_proto$p,
    merge: $$let$3.merge,
    to_json: $$let$3.to_json,
    from_json_exn: $$let$3.from_json_exn,
    from_json: $$let$3.from_json
  })
]));

function merge$4(t1, t2) {
  return {
    document: Curry._2(merge_document$1, t1.document, t2.document)
  };
}

function spec$4(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_document.Buhta.$$Document.V1alpha1.$$Document;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "document",
      "document"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
});

function to_proto$p$4(writer, param) {
  Curry._2(serialize$4, writer, param.document);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8($$document) {
  return {
    document: $$document
  };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
});

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$4, writer);
  });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.CreateDocumentRequest", spec$4(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.document);
  };
}

function constructor$9($$document) {
  return {
    document: $$document
  };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.CreateDocumentRequest", spec$4(undefined), constructor$9);
});

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$4, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, CreateDocumentRequest, {
  make: make$4,
  to_proto: to_proto$4,
  from_proto: from_proto$4,
  to_json: to_json$4,
  from_json: from_json$4,
  name: name$4,
  merge: merge$4,
  to_proto$p: to_proto$p$4,
  from_proto_exn: from_proto_exn$4,
  from_json_exn: from_json_exn$4
});

function name$5(param) {
  return ".buhta.edo.document.v1alpha1.CreateDocumentResponse";
}

function make$5($$document, param) {
  return {
    document: $$document
  };
}

const $$let$4 = Buhta_documentapis__Buhta_document_v1alpha1_document.Buhta.$$Document.V1alpha1.$$Document;

const merge_document$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "document",
    "document"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$4.name,
    make: $$let$4.make,
    from_proto: $$let$4.from_proto,
    from_proto_exn: $$let$4.from_proto_exn,
    to_proto: $$let$4.to_proto,
    to_proto$p: $$let$4.to_proto$p,
    merge: $$let$4.merge,
    to_json: $$let$4.to_json,
    from_json_exn: $$let$4.from_json_exn,
    from_json: $$let$4.from_json
  })
]));

function merge$5(t1, t2) {
  return {
    document: Curry._2(merge_document$2, t1.document, t2.document)
  };
}

function spec$5(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_document.Buhta.$$Document.V1alpha1.$$Document;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "document",
      "document"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
});

function to_proto$p$5(writer, param) {
  Curry._2(serialize$5, writer, param.document);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10($$document) {
  return {
    document: $$document
  };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
});

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$5, writer);
  });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.CreateDocumentResponse", spec$5(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.document);
  };
}

function constructor$11($$document) {
  return {
    document: $$document
  };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.CreateDocumentResponse", spec$5(undefined), constructor$11);
});

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$5, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, CreateDocumentResponse, {
  make: make$5,
  to_proto: to_proto$5,
  from_proto: from_proto$5,
  to_json: to_json$5,
  from_json: from_json$5,
  name: name$5,
  merge: merge$5,
  to_proto$p: to_proto$p$5,
  from_proto_exn: from_proto_exn$5,
  from_json_exn: from_json_exn$5
});

const DocumentData = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_service.ml",
  2029,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$6(param) {
  return ".buhta.edo.document.v1alpha1.UpdateDocumentRequest.DocumentData";
}

function make$6(param) {
  
}

function merge$6(param, param$1) {
  
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
});

function to_proto$p$6(writer, param) {
  Curry._1(serialize$6, writer);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize$6, writer);
  return writer;
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_proto_exn$6, writer);
  });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.UpdateDocumentRequest.DocumentData", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.UpdateDocumentRequest.DocumentData", Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_json_exn$6, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, DocumentData, {
  make: make$6,
  to_proto: to_proto$6,
  from_proto: from_proto$6,
  to_json: to_json$6,
  from_json: from_json$6,
  name: name$6,
  merge: merge$6,
  to_proto$p: to_proto$p$6,
  from_proto_exn: from_proto_exn$6,
  from_json_exn: from_json_exn$6
});

function name$7(param) {
  return ".buhta.edo.document.v1alpha1.UpdateDocumentRequest";
}

function make$7(idOpt, $$document, param) {
  const id = idOpt !== undefined ? idOpt : "";
  return {
    id: id,
    document: $$document
  };
}

const merge_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const $$let$5 = Buhta_documentapis__Buhta_document_v1alpha1_document.Buhta.$$Document.V1alpha1.$$Document;

const merge_document$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "document",
    "document"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$5.name,
    make: $$let$5.make,
    from_proto: $$let$5.from_proto,
    from_proto_exn: $$let$5.from_proto_exn,
    to_proto: $$let$5.to_proto,
    to_proto$p: $$let$5.to_proto$p,
    merge: $$let$5.merge,
    to_json: $$let$5.to_json,
    from_json_exn: $$let$5.from_json_exn,
    from_json: $$let$5.from_json
  })
]));

function merge$7(t1, t2) {
  return {
    id: Curry._2(merge_id$1, t1.id, t2.id),
    document: Curry._2(merge_document$3, t1.document, t2.document)
  };
}

function spec$6(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_document.Buhta.$$Document.V1alpha1.$$Document;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "document",
      "document"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
});

function to_proto$p$7(writer, param) {
  Curry._3(serialize$7, writer, param.id, param.document);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$12(id, $$document) {
  return {
    id: id,
    document: $$document
  };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
});

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$7, writer);
  });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.UpdateDocumentRequest", spec$6(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.document);
  };
}

function constructor$13(id, $$document) {
  return {
    id: id,
    document: $$document
  };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.UpdateDocumentRequest", spec$6(undefined), constructor$13);
});

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$7, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "DocumentData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, UpdateDocumentRequest, {
  DocumentData: DocumentData,
  make: make$7,
  to_proto: to_proto$7,
  from_proto: from_proto$7,
  to_json: to_json$7,
  from_json: from_json$7,
  name: name$7,
  merge: merge$7,
  to_proto$p: to_proto$p$7,
  from_proto_exn: from_proto_exn$7,
  from_json_exn: from_json_exn$7
});

function name$8(param) {
  return ".buhta.edo.document.v1alpha1.UpdateDocumentResponse";
}

function make$8($$document, param) {
  return {
    document: $$document
  };
}

const $$let$6 = Buhta_documentapis__Buhta_document_v1alpha1_document.Buhta.$$Document.V1alpha1.$$Document;

const merge_document$4 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "document",
    "document"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$6.name,
    make: $$let$6.make,
    from_proto: $$let$6.from_proto,
    from_proto_exn: $$let$6.from_proto_exn,
    to_proto: $$let$6.to_proto,
    to_proto$p: $$let$6.to_proto$p,
    merge: $$let$6.merge,
    to_json: $$let$6.to_json,
    from_json_exn: $$let$6.from_json_exn,
    from_json: $$let$6.from_json
  })
]));

function merge$8(t1, t2) {
  return {
    document: Curry._2(merge_document$4, t1.document, t2.document)
  };
}

function spec$7(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_document.Buhta.$$Document.V1alpha1.$$Document;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "document",
      "document"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
});

function to_proto$p$8(writer, param) {
  Curry._2(serialize$8, writer, param.document);
}

function to_proto$8(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$8(writer, t);
  return writer;
}

function constructor$14($$document) {
  return {
    document: $$document
  };
}

const from_proto_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
});

function from_proto$8(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$8, writer);
  });
}

function to_json$8(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.UpdateDocumentResponse", spec$7(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.document);
  };
}

function constructor$15($$document) {
  return {
    document: $$document
  };
}

const from_json_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.UpdateDocumentResponse", spec$7(undefined), constructor$15);
});

function from_json$8(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$8, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, UpdateDocumentResponse, {
  make: make$8,
  to_proto: to_proto$8,
  from_proto: from_proto$8,
  to_json: to_json$8,
  from_json: from_json$8,
  name: name$8,
  merge: merge$8,
  to_proto$p: to_proto$p$8,
  from_proto_exn: from_proto_exn$8,
  from_json_exn: from_json_exn$8
});

function name$9(param) {
  return ".buhta.edo.document.v1alpha1.DeleteDocumentRequest";
}

function make$9(idOpt, param) {
  const id = idOpt !== undefined ? idOpt : "";
  return {
    id: id
  };
}

const merge_id$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$9(t1, t2) {
  return {
    id: Curry._2(merge_id$2, t1.id, t2.id)
  };
}

function spec$8(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$8(undefined));
});

function to_proto$p$9(writer, param) {
  Curry._2(serialize$9, writer, param.id);
}

function to_proto$9(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$9(writer, t);
  return writer;
}

function constructor$16(id) {
  return {
    id: id
  };
}

const from_proto_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$8(undefined), constructor$16);
});

function from_proto$9(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$9, writer);
  });
}

function to_json$9(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.DeleteDocumentRequest", spec$8(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.id);
  };
}

function constructor$17(id) {
  return {
    id: id
  };
}

const from_json_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.DeleteDocumentRequest", spec$8(undefined), constructor$17);
});

function from_json$9(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$9, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, DeleteDocumentRequest, {
  make: make$9,
  to_proto: to_proto$9,
  from_proto: from_proto$9,
  to_json: to_json$9,
  from_json: from_json$9,
  name: name$9,
  merge: merge$9,
  to_proto$p: to_proto$p$9,
  from_proto_exn: from_proto_exn$9,
  from_json_exn: from_json_exn$9
});

function name$10(param) {
  return ".buhta.edo.document.v1alpha1.DeleteDocumentResponse";
}

function make$10(param) {
  
}

function merge$10(param, param$1) {
  
}

const serialize$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
});

function to_proto$p$10(writer, param) {
  Curry._1(serialize$10, writer);
}

function to_proto$10(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize$10, writer);
  return writer;
}

const from_proto_exn$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_proto$10(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_proto_exn$10, writer);
  });
}

function to_json$10(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.DeleteDocumentResponse", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.DeleteDocumentResponse", Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_json$10(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_json_exn$10, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, DeleteDocumentResponse, {
  make: make$10,
  to_proto: to_proto$10,
  from_proto: from_proto$10,
  to_json: to_json$10,
  from_json: from_json$10,
  name: name$10,
  merge: merge$10,
  to_proto$p: to_proto$p$10,
  from_proto_exn: from_proto_exn$10,
  from_json_exn: from_json_exn$10
});

const getDocument_0 = {
  name: GetDocumentRequest.name,
  make: GetDocumentRequest.make,
  from_proto: GetDocumentRequest.from_proto,
  from_proto_exn: GetDocumentRequest.from_proto_exn,
  to_proto: GetDocumentRequest.to_proto,
  to_proto$p: GetDocumentRequest.to_proto$p,
  merge: GetDocumentRequest.merge,
  to_json: GetDocumentRequest.to_json,
  from_json_exn: GetDocumentRequest.from_json_exn,
  from_json: GetDocumentRequest.from_json
};

const getDocument_1 = {
  name: GetDocumentResponse.name,
  make: GetDocumentResponse.make,
  from_proto: GetDocumentResponse.from_proto,
  from_proto_exn: GetDocumentResponse.from_proto_exn,
  to_proto: GetDocumentResponse.to_proto,
  to_proto$p: GetDocumentResponse.to_proto$p,
  merge: GetDocumentResponse.merge,
  to_json: GetDocumentResponse.to_json,
  from_json_exn: GetDocumentResponse.from_json_exn,
  from_json: GetDocumentResponse.from_json
};

const getDocument = [
  getDocument_0,
  getDocument_1
];

const listDocuments_0 = {
  name: ListDocumentsRequest.name,
  make: ListDocumentsRequest.make,
  from_proto: ListDocumentsRequest.from_proto,
  from_proto_exn: ListDocumentsRequest.from_proto_exn,
  to_proto: ListDocumentsRequest.to_proto,
  to_proto$p: ListDocumentsRequest.to_proto$p,
  merge: ListDocumentsRequest.merge,
  to_json: ListDocumentsRequest.to_json,
  from_json_exn: ListDocumentsRequest.from_json_exn,
  from_json: ListDocumentsRequest.from_json
};

const listDocuments_1 = {
  name: ListDocumentsResponse.name,
  make: ListDocumentsResponse.make,
  from_proto: ListDocumentsResponse.from_proto,
  from_proto_exn: ListDocumentsResponse.from_proto_exn,
  to_proto: ListDocumentsResponse.to_proto,
  to_proto$p: ListDocumentsResponse.to_proto$p,
  merge: ListDocumentsResponse.merge,
  to_json: ListDocumentsResponse.to_json,
  from_json_exn: ListDocumentsResponse.from_json_exn,
  from_json: ListDocumentsResponse.from_json
};

const listDocuments = [
  listDocuments_0,
  listDocuments_1
];

const createDocument_0 = {
  name: CreateDocumentRequest.name,
  make: CreateDocumentRequest.make,
  from_proto: CreateDocumentRequest.from_proto,
  from_proto_exn: CreateDocumentRequest.from_proto_exn,
  to_proto: CreateDocumentRequest.to_proto,
  to_proto$p: CreateDocumentRequest.to_proto$p,
  merge: CreateDocumentRequest.merge,
  to_json: CreateDocumentRequest.to_json,
  from_json_exn: CreateDocumentRequest.from_json_exn,
  from_json: CreateDocumentRequest.from_json
};

const createDocument_1 = {
  name: CreateDocumentResponse.name,
  make: CreateDocumentResponse.make,
  from_proto: CreateDocumentResponse.from_proto,
  from_proto_exn: CreateDocumentResponse.from_proto_exn,
  to_proto: CreateDocumentResponse.to_proto,
  to_proto$p: CreateDocumentResponse.to_proto$p,
  merge: CreateDocumentResponse.merge,
  to_json: CreateDocumentResponse.to_json,
  from_json_exn: CreateDocumentResponse.from_json_exn,
  from_json: CreateDocumentResponse.from_json
};

const createDocument = [
  createDocument_0,
  createDocument_1
];

const updateDocument_0 = {
  name: UpdateDocumentRequest.name,
  make: UpdateDocumentRequest.make,
  from_proto: UpdateDocumentRequest.from_proto,
  from_proto_exn: UpdateDocumentRequest.from_proto_exn,
  to_proto: UpdateDocumentRequest.to_proto,
  to_proto$p: UpdateDocumentRequest.to_proto$p,
  merge: UpdateDocumentRequest.merge,
  to_json: UpdateDocumentRequest.to_json,
  from_json_exn: UpdateDocumentRequest.from_json_exn,
  from_json: UpdateDocumentRequest.from_json
};

const updateDocument_1 = {
  name: UpdateDocumentResponse.name,
  make: UpdateDocumentResponse.make,
  from_proto: UpdateDocumentResponse.from_proto,
  from_proto_exn: UpdateDocumentResponse.from_proto_exn,
  to_proto: UpdateDocumentResponse.to_proto,
  to_proto$p: UpdateDocumentResponse.to_proto$p,
  merge: UpdateDocumentResponse.merge,
  to_json: UpdateDocumentResponse.to_json,
  from_json_exn: UpdateDocumentResponse.from_json_exn,
  from_json: UpdateDocumentResponse.from_json
};

const updateDocument = [
  updateDocument_0,
  updateDocument_1
];

const deleteDocument_0 = {
  name: DeleteDocumentRequest.name,
  make: DeleteDocumentRequest.make,
  from_proto: DeleteDocumentRequest.from_proto,
  from_proto_exn: DeleteDocumentRequest.from_proto_exn,
  to_proto: DeleteDocumentRequest.to_proto,
  to_proto$p: DeleteDocumentRequest.to_proto$p,
  merge: DeleteDocumentRequest.merge,
  to_json: DeleteDocumentRequest.to_json,
  from_json_exn: DeleteDocumentRequest.from_json_exn,
  from_json: DeleteDocumentRequest.from_json
};

const deleteDocument_1 = {
  name: DeleteDocumentResponse.name,
  make: DeleteDocumentResponse.make,
  from_proto: DeleteDocumentResponse.from_proto,
  from_proto_exn: DeleteDocumentResponse.from_proto_exn,
  to_proto: DeleteDocumentResponse.to_proto,
  to_proto$p: DeleteDocumentResponse.to_proto$p,
  merge: DeleteDocumentResponse.merge,
  to_json: DeleteDocumentResponse.to_json,
  from_json_exn: DeleteDocumentResponse.from_json_exn,
  from_json: DeleteDocumentResponse.from_json
};

const deleteDocument = [
  deleteDocument_0,
  deleteDocument_1
];

const V1alpha1_DocumentService = {
  GetDocument: {
    name: "/buhta.edo.document.v1alpha1.DocumentService/GetDocument",
    package_name: "buhta.edo.document.v1alpha1",
    service_name: "DocumentService",
    method_name: "GetDocument",
    $$Request: {
      name: GetDocumentRequest.name,
      make: GetDocumentRequest.make,
      from_proto: GetDocumentRequest.from_proto,
      from_proto_exn: GetDocumentRequest.from_proto_exn,
      to_proto: GetDocumentRequest.to_proto,
      to_proto$p: GetDocumentRequest.to_proto$p,
      merge: GetDocumentRequest.merge,
      to_json: GetDocumentRequest.to_json,
      from_json_exn: GetDocumentRequest.from_json_exn,
      from_json: GetDocumentRequest.from_json
    },
    $$Response: {
      name: GetDocumentResponse.name,
      make: GetDocumentResponse.make,
      from_proto: GetDocumentResponse.from_proto,
      from_proto_exn: GetDocumentResponse.from_proto_exn,
      to_proto: GetDocumentResponse.to_proto,
      to_proto$p: GetDocumentResponse.to_proto$p,
      merge: GetDocumentResponse.merge,
      to_json: GetDocumentResponse.to_json,
      from_json_exn: GetDocumentResponse.from_json_exn,
      from_json: GetDocumentResponse.from_json
    }
  },
  getDocument: getDocument,
  ListDocuments: {
    name: "/buhta.edo.document.v1alpha1.DocumentService/ListDocuments",
    package_name: "buhta.edo.document.v1alpha1",
    service_name: "DocumentService",
    method_name: "ListDocuments",
    $$Request: {
      name: ListDocumentsRequest.name,
      make: ListDocumentsRequest.make,
      from_proto: ListDocumentsRequest.from_proto,
      from_proto_exn: ListDocumentsRequest.from_proto_exn,
      to_proto: ListDocumentsRequest.to_proto,
      to_proto$p: ListDocumentsRequest.to_proto$p,
      merge: ListDocumentsRequest.merge,
      to_json: ListDocumentsRequest.to_json,
      from_json_exn: ListDocumentsRequest.from_json_exn,
      from_json: ListDocumentsRequest.from_json
    },
    $$Response: {
      name: ListDocumentsResponse.name,
      make: ListDocumentsResponse.make,
      from_proto: ListDocumentsResponse.from_proto,
      from_proto_exn: ListDocumentsResponse.from_proto_exn,
      to_proto: ListDocumentsResponse.to_proto,
      to_proto$p: ListDocumentsResponse.to_proto$p,
      merge: ListDocumentsResponse.merge,
      to_json: ListDocumentsResponse.to_json,
      from_json_exn: ListDocumentsResponse.from_json_exn,
      from_json: ListDocumentsResponse.from_json
    }
  },
  listDocuments: listDocuments,
  CreateDocument: {
    name: "/buhta.edo.document.v1alpha1.DocumentService/CreateDocument",
    package_name: "buhta.edo.document.v1alpha1",
    service_name: "DocumentService",
    method_name: "CreateDocument",
    $$Request: {
      name: CreateDocumentRequest.name,
      make: CreateDocumentRequest.make,
      from_proto: CreateDocumentRequest.from_proto,
      from_proto_exn: CreateDocumentRequest.from_proto_exn,
      to_proto: CreateDocumentRequest.to_proto,
      to_proto$p: CreateDocumentRequest.to_proto$p,
      merge: CreateDocumentRequest.merge,
      to_json: CreateDocumentRequest.to_json,
      from_json_exn: CreateDocumentRequest.from_json_exn,
      from_json: CreateDocumentRequest.from_json
    },
    $$Response: {
      name: CreateDocumentResponse.name,
      make: CreateDocumentResponse.make,
      from_proto: CreateDocumentResponse.from_proto,
      from_proto_exn: CreateDocumentResponse.from_proto_exn,
      to_proto: CreateDocumentResponse.to_proto,
      to_proto$p: CreateDocumentResponse.to_proto$p,
      merge: CreateDocumentResponse.merge,
      to_json: CreateDocumentResponse.to_json,
      from_json_exn: CreateDocumentResponse.from_json_exn,
      from_json: CreateDocumentResponse.from_json
    }
  },
  createDocument: createDocument,
  UpdateDocument: {
    name: "/buhta.edo.document.v1alpha1.DocumentService/UpdateDocument",
    package_name: "buhta.edo.document.v1alpha1",
    service_name: "DocumentService",
    method_name: "UpdateDocument",
    $$Request: {
      name: UpdateDocumentRequest.name,
      make: UpdateDocumentRequest.make,
      from_proto: UpdateDocumentRequest.from_proto,
      from_proto_exn: UpdateDocumentRequest.from_proto_exn,
      to_proto: UpdateDocumentRequest.to_proto,
      to_proto$p: UpdateDocumentRequest.to_proto$p,
      merge: UpdateDocumentRequest.merge,
      to_json: UpdateDocumentRequest.to_json,
      from_json_exn: UpdateDocumentRequest.from_json_exn,
      from_json: UpdateDocumentRequest.from_json
    },
    $$Response: {
      name: UpdateDocumentResponse.name,
      make: UpdateDocumentResponse.make,
      from_proto: UpdateDocumentResponse.from_proto,
      from_proto_exn: UpdateDocumentResponse.from_proto_exn,
      to_proto: UpdateDocumentResponse.to_proto,
      to_proto$p: UpdateDocumentResponse.to_proto$p,
      merge: UpdateDocumentResponse.merge,
      to_json: UpdateDocumentResponse.to_json,
      from_json_exn: UpdateDocumentResponse.from_json_exn,
      from_json: UpdateDocumentResponse.from_json
    }
  },
  updateDocument: updateDocument,
  DeleteDocument: {
    name: "/buhta.edo.document.v1alpha1.DocumentService/DeleteDocument",
    package_name: "buhta.edo.document.v1alpha1",
    service_name: "DocumentService",
    method_name: "DeleteDocument",
    $$Request: {
      name: DeleteDocumentRequest.name,
      make: DeleteDocumentRequest.make,
      from_proto: DeleteDocumentRequest.from_proto,
      from_proto_exn: DeleteDocumentRequest.from_proto_exn,
      to_proto: DeleteDocumentRequest.to_proto,
      to_proto$p: DeleteDocumentRequest.to_proto$p,
      merge: DeleteDocumentRequest.merge,
      to_json: DeleteDocumentRequest.to_json,
      from_json_exn: DeleteDocumentRequest.from_json_exn,
      from_json: DeleteDocumentRequest.from_json
    },
    $$Response: {
      name: DeleteDocumentResponse.name,
      make: DeleteDocumentResponse.make,
      from_proto: DeleteDocumentResponse.from_proto,
      from_proto_exn: DeleteDocumentResponse.from_proto_exn,
      to_proto: DeleteDocumentResponse.to_proto,
      to_proto$p: DeleteDocumentResponse.to_proto$p,
      merge: DeleteDocumentResponse.merge,
      to_json: DeleteDocumentResponse.to_json,
      from_json_exn: DeleteDocumentResponse.from_json_exn,
      from_json: DeleteDocumentResponse.from_json
    }
  },
  deleteDocument: deleteDocument
};

const V1alpha1 = {
  GetDocumentRequest: GetDocumentRequest,
  GetDocumentResponse: GetDocumentResponse,
  ListDocumentsRequest: ListDocumentsRequest,
  ListDocumentsResponse: ListDocumentsResponse,
  CreateDocumentRequest: CreateDocumentRequest,
  CreateDocumentResponse: CreateDocumentResponse,
  UpdateDocumentRequest: UpdateDocumentRequest,
  UpdateDocumentResponse: UpdateDocumentResponse,
  DeleteDocumentRequest: DeleteDocumentRequest,
  DeleteDocumentResponse: DeleteDocumentResponse,
  DocumentService: V1alpha1_DocumentService
};

const $$Document = {
  V1alpha1: V1alpha1
};

const Edo = {
  $$Document: $$Document
};

const Buhta = {
  Edo: Edo
};

export {
  Imported$pmodules,
  Buhta,
}
/* GetDocumentRequest Not a pure module */
